import paymentMethodsInfo from '@assets/images/payment-methods-info.webp';



export const PaymentInfo = () => {

	return (
		<div className='app-payment-info'>
			<img src={paymentMethodsInfo} alt='payment methods info' />
		</div>
	);
}